import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
}

const ModalInactivity = ({ isOpen, onConfirm }: Props) => {
  return (
    <div className="flex justify-center mb-xxlg">
      <CcModal visible={isOpen} hideCloseButton>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            ¿Sigues ahí?
          </h2>
          <p className="text-center text-color-02">
            Notamos que llevas varios minutos ausente. Para seguir sin
            interrupciones, te pedimos confirmar si deseas continuar tu examen.
          </p>
        </div>
        <div className="flex justify-center gap-lg modal-buttons">
          <Button
            text="Continuar examen"
            color="primary"
            onClick={onConfirm}
            data-testid="btn-confirm"
          />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalInactivity;
